<mat-form-field appearance="outline" floatLabel="always" color="white" [ngClass]="inputClass">
  <mat-label><ng-content></ng-content></mat-label>

  <input
    matInput
    autocomplete="off"
    [name]="name"
    [placeholder]="placeholder"
    [formControl]="control"
    [required]="required"
    [readonly]="!!readonly"
    [appAutoFocus]="autofocus"
    (focus)="focus.emit($event)"
  />

  @if (suffixAction !== 'clear' || control.value) {
    <ng-container matSuffix>
      @if (control.value) {
        <app-lex-icon-button
          [@suffixIconIn]
          [matIcon]="suffixIcon"
          (mousedown)="focus.emit($event)"
          (click)="onSuffixActionClicked()"
        ></app-lex-icon-button>
      }
    </ng-container>
  } @else {
    @if (suffixIcon !== 'close') {
      <mat-icon [@suffixIconIn] matSuffix>{{ suffixIcon }}</mat-icon>
    }
  }

  <mat-error>{{ errorMessage }}</mat-error>
</mat-form-field>
